import * as React from "react";
import { ChronologyListRecord } from "./chronologyListRecord";
import { type ChronoEntry, type DocumentChronology } from "@/types/chronology";

interface Props {
  chronoRecords: ChronoEntry[];
  showAddRow: boolean;
  toggleAddRow: () => void;
  documentChronology: DocumentChronology;
  documentId: string;
}

export const ChronologyListTable: React.FC<Props> = ({
  toggleAddRow,
  documentChronology,
  showAddRow,
  chronoRecords,
  documentId,
}) => (
  <table className="min-w-full divide-y divide-gray-300">
    <tbody className="divide-y divide-gray-200 bg-white">
      {chronoRecords.map((chronoRecord, index) => (
        <ChronologyListRecord
          documentChronology={documentChronology}
          index={index}
          chronoRecord={chronoRecord}
          key={chronoRecord.id}
          documentId={documentId}
        />
      ))}
      {showAddRow && (
        <ChronologyListRecord
          onSave={toggleAddRow}
          documentChronology={documentChronology}
          initIsEditable={true}
          documentId={documentId}
          index={chronoRecords.length}
        />
      )}
    </tbody>
  </table>
);
